import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { MyUploadFile } from "../../molecules";
import { useDispatch } from "react-redux";
import { getBase64 } from "../../../utils/constansColors";
import {
  downloadHistoryDocument,
  getExcoDocument,
  listHistoryDocument,
} from "../../../config/Redux/Global/actions";
import { useParams } from "react-router-dom";
import { Gap, MyButton } from "../../atoms";
import {
  deleteDocument,
  uploadDocument,
  downloadDocument,
} from "../../../config/Redux/Global/actions";
import MyDialog from "../../molecules/Dialog";
import HelpIcon from "@mui/icons-material/Help";
import AlertMessage from "../../../components/molecules/AlertMessage";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";

const DokumenKantor = ({
  dataDoc,
  nameExco,
  officeId: propOfficeId,
  isLocked,
}) => {
  let exco_default = dataDoc;
  let exco_kecamatan = dataDoc?.filter(
    (item) => item.kategori_dokumen.id === 3,
  );

  let resultArr = [];

  if (
    nameExco === "EXCO Kelurahan/Desa" ||
    nameExco?.includes("EXCO RT") ||
    nameExco === "Komisaris Basis"
  ) {
    resultArr = exco_kecamatan;
  } else {
    resultArr = exco_default;
  }
  const dispatch = useDispatch();
  let params = useParams();
  const officeId = propOfficeId || params.officeId;
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const [fileNameKantor, setFileNameKantor] = React.useState(null);
  const [fileNameSewaKantor, setFileNameSewaKantor] = React.useState(null);
  const [fileNameDomisiliKantor, setFileNameDomisiliKantor] =
    React.useState(null);

  // dialog alert
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  // delete doc
  const [categoryDoc, setCategoryDoc] = React.useState(null);
  const [idDocument, setIdDocument] = React.useState(null);
  const [docName, setDocName] = React.useState(null);
  const [documentView, setDocumentView] = React.useState(null);

  // loading
  const [loading, setLoading] = React.useState(false);

  const handleCloseDialogDelete = () => {
    setOpenDelete(false);
  };
  const handleCloseDialogView = () => {
    setOpenView(false);
  };

  const [openHistory, setOpenHistory] = React.useState(false);
  const [dataHistoryDokumen, setDataHistoryDokumen] = React.useState(null);
  const handleCloseDialogHistory = () => {
    setOpenHistory(false);
  };

  const handleselectedFiles = async (event, param) => {
    let base64 = await getBase64(event);
    // Unggah Foto Kantor* 3
    if (param === 3) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "3",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameKantor(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Foto Kantor</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    // Unggah Perjanjian Sewa Kantor* 4
    if (param === 4) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "4",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };
      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameSewaKantor(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Perjanjian Sewa Kantor</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    //Unggah Surat Keterangan domisili Kantor* 5
    if (param === 5) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "5",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };
      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameDomisiliKantor(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>SK Domisili Kantor</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
  };

  const handleOpenDelete = (categoryDoc, idDocument, docName) => {
    setCategoryDoc(categoryDoc);
    setIdDocument(idDocument);
    setDocName(docName);
    setOpenDelete(true);
  };

  const base64ToBlob = (base64, type = "application/octet-stream") => {
    // const binStr = atob(base64);
    const binStr = atob(base64.split(",")[1]);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  const handleDeleteFile = async (param, id) => {
    // Unggah Foto Kantor* 3
    if (param === 3) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameKantor(null);
        setOpenDelete(false);
      }
    }
    // Unggah Perjanjian Sewa Kantor* 4
    if (param === 4) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameSewaKantor(null);
        setOpenDelete(false);
      }
    }
    // Unggah Surat Keterangan domisili Kantor* 5
    if (param === 5) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameDomisiliKantor(null);
        setOpenDelete(false);
      }
    }
  };

  // download file
  const handleDownloadDoc = async (param, id) => {
    // Unggah Foto Kantor* 3
    if (param === 3) {
      const resp = await dispatch(downloadDocument(id));

      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        // let resultData = `data:application/pdf;base64,${data}`;
        let resultData = `${data}`;
        let a = document.createElement("a");
        a.href = resultData;
        a.download = resp.payload.file_name;
        a.click();
      }
    }
    // Unggah Perjanjian Sewa Kantor* 4
    if (param === 4) {
      const resp = await dispatch(downloadDocument(id));
      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        // let resultData = `data:application/pdf;base64,${data}`;
        let resultData = `${data}`;
        let a = document.createElement("a");
        a.href = resultData;
        a.download = resp.payload.file_name;
        a.click();
      }
    }
    // Unggah Surat Keterangan domisili Kantor* 5
    if (param === 5) {
      const resp = await dispatch(downloadDocument(id));

      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        // let resultData = `data:application/pdf;base64,${data}`;
        let resultData = `${data}`;
        let a = document.createElement("a");
        a.href = resultData;
        a.download = resp.payload.file_name;
        a.click();
      }
    }
  };

  // handle view file
  const handleViewDoc = async (param, id) => {
    // Unggah Foto Kantor* 3
    if (param === 3) {
      const resp = await dispatch(downloadDocument(id));

      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        let resultData = `${data}`;
        const blob = base64ToBlob(resultData, "application/pdf");
        const url = URL.createObjectURL(blob);
        setDocumentView(url);
        setOpenView(true);
      }
    }
    // Unggah Perjanjian Sewa Kantor* 4
    if (param === 4) {
      const resp = await dispatch(downloadDocument(id));
      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        let resultData = `${data}`;
        const blob = base64ToBlob(resultData, "application/pdf");
        const url = URL.createObjectURL(blob);
        setDocumentView(url);
        setOpenView(true);
        // setFileNameMenkumham(null);
        // setOpenDelete(false);
      }
    }
    // Unggah Surat Keterangan domisili Kantor* 5
    if (param === 5) {
      const resp = await dispatch(downloadDocument(id));
      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        let resultData = `${data}`;
        const blob = base64ToBlob(resultData, "application/pdf");
        const url = URL.createObjectURL(blob);
        setDocumentView(url);
        setOpenView(true);
        // setFileNameMenkumhamAD(null);
        // setOpenDelete(false);
      }
    }
  };

  useEffect(() => {
    resultArr &&
      resultArr.map((item) => {
        let fileNameKantor = "";
        let fileNameSewaKantor = "";
        let fileNameDomisiliKantor = "";
        if (item.kategori_dokumen.id === 3) {
          fileNameKantor = item.nama_dokumen;
          setFileNameKantor(fileNameKantor);
        }
        if (item.kategori_dokumen.id === 4) {
          fileNameSewaKantor = item.nama_dokumen;
          setFileNameSewaKantor(fileNameSewaKantor);
        }
        if (item.kategori_dokumen.id === 5) {
          fileNameDomisiliKantor = item.nama_dokumen;
          setFileNameDomisiliKantor(fileNameDomisiliKantor);
        }
        return null;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataDoc]);

  const renderValueDelete = (
    <div align="center">
      <HelpIcon style={{ fontSize: 60, color: "#F06524" }} />
      <h3>Perhatian!</h3>
      <p>
        Yakin Untuk Menghapus File <br /> <b>{docName}</b> ?
      </p>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Batal"
          borderColor="#F06524"
          onClick={handleCloseDialogDelete}
          style={{ width: "100%" }}
        />
        <Gap width={10} />
        <MyButton
          component="span"
          color="#FFFFFF"
          backgroundColor="#F06524"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Hapus"
          borderColor="#F06524"
          style={{ width: "100%" }}
          onClick={() => handleDeleteFile(categoryDoc, idDocument)}
        />
      </div>
    </div>
  );

  const renderValueView = (
    <>
      <iframe
        title="pdfView"
        src={documentView}
        style={{ width: "100%", height: "80vh" }}
      ></iframe>
    </>
  );

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  //cek hak akses
  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
    });
    return has;
  };

  // handle history file
  const handleHistoryDokumen = async (param, id) => {
    setOpenHistory(true);
    const resp = await dispatch(listHistoryDocument(officeId, param));
    if (resp.type === "LIST_HISTORY_DOCUMENT_SUCCESS") {
      let data = await resp.payload.data;
      setDataHistoryDokumen(data);
    }
  };
  const handleDownloadHistoryDokumen = async (id) => {
    const resp = await dispatch(downloadHistoryDocument(id));
    if (resp.type === "DOWNLOAD_HISTORY_DOCUMENT_SUCCESS") {
      let data = await resp.payload.dokumen;
      let a = document.createElement("a");
      a.href = data;
      a.download = resp.payload.file_name;
      a.click();
    }
  };
  const convertDate = (date) => {
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    var local = new Date(date);
    return (
      local.getDate() +
      " " +
      months[local.getMonth()] +
      " " +
      local.getFullYear()
    );
  };

  const renderHistoryFile = (
    <div align="center">
      <h3>Riwayat Perubahan Dokumen</h3>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                No.
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Aksi Peubahan
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Nama Dokumen
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Waktu Perubahan
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Oleh
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Unduh
              </th>
            </tr>
          </thead>
          <tbody>
            {dataHistoryDokumen?.map((item, key) => {
              return (
                <tr key={key} style={{ borderBottom: "#96D4D4 solid 1px" }}>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {key + 1}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.action}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    <div style={{ wordWrap: "break-word" }}>
                      {item.new_value}
                    </div>
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {convertDate(item.created_date)}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.pembuat?.nama}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.action !== "DELETE" ? (
                      <button
                        onClick={() =>
                          handleDownloadHistoryDokumen(item.id_record)
                        }
                        style={{
                          cursor: "pointer",
                          backgroundColor: "white",
                          margin: "6px",
                          padding: "6px 8px",
                          border: "2px rgb(240, 101, 36) solid",
                          color: "rgb(240, 101, 36)",
                          borderRadius: "6px",
                        }}
                      >
                        Unduh Dokumen
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Kembali"
          borderColor="#F06524"
          onClick={handleCloseDialogHistory}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );

  return (
    <>
      <MyDialog
        openDialog={openHistory}
        handleCloseDialog={handleCloseDialogHistory}
        renderValue={renderHistoryFile}
        fullWidth={true}
        maxWidth={"medium"}
      />

      {/* delete file */}
      <MyDialog
        openDialog={openDelete}
        handleCloseDialog={handleCloseDialogDelete}
        renderValue={renderValueDelete}
        // fullWidth={true}
        // maxWidth={"medium"}
      />
      {/* view file pdf */}
      <MyDialog
        openDialog={openView}
        handleCloseDialog={handleCloseDialogView}
        renderValue={renderValueView}
        fullWidth={true}
        maxWidth={"medium"}
      />

      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />

      {/* <p style={{ fontSize: 24, color: "#757575" }}>Dokumen Kantor</p> */}
      <Grid container spacing={3}>
        {/* Unggah foto kantor */}
        {resultArr?.map((item, key) => {
          return (
            <Grid item xs={12} md={6} key={key}>
              <MyUploadFile
                hasAccess={
                  !isLocked &&
                  (checkHakAkses(
                    profile?.data?.hak_akses,
                    "Document Admin Access",
                  ) ||
                    checkHakAkses(
                      profile?.data?.hak_akses,
                      "Document Manager Access",
                    ))
                    ? true
                    : false
                }
                loading={loading}
                formatLabel={
                  item?.kategori_dokumen?.nama === "Foto Kantor"
                    ? "Foto menampilkan bangunan kantor, papan nama kantor, dan sebagian jalan di depannya, Format: pdf"
                    : null
                }
                label={`Unggah ${
                  item?.kategori_dokumen?.id !== 3 ? "Scan" : ""
                } ${item?.kategori_dokumen?.nama}${
                  nameExco === "EXCO Provinsi" ||
                  nameExco === "EXCO Kabupaten/Kota" ||
                  nameExco === "EXCO KabKot" ||
                  nameExco === "EXCO Kecamatan"
                    ? ""
                    : "*"
                }`}
                handleselectedFile={(e) =>
                  handleselectedFiles(e, item?.kategori_dokumen?.id)
                }
                fileName={
                  item?.kategori_dokumen?.id === 3
                    ? fileNameKantor
                    : item?.kategori_dokumen?.id === 4
                      ? fileNameSewaKantor
                      : item?.kategori_dokumen?.id === 5
                        ? fileNameDomisiliKantor
                        : null
                }
                handleDeleteFile={() => {
                  handleOpenDelete(
                    item?.kategori_dokumen?.id,
                    item?.id_dokumen,
                    item?.kategori_dokumen?.nama,
                  );
                }}
                handleDownloadFile={() => {
                  handleDownloadDoc(
                    item?.kategori_dokumen?.id,
                    item?.id_dokumen,
                  );
                }}
                handleView={() => {
                  handleViewDoc(item?.kategori_dokumen?.id, item?.id_dokumen);
                }}
                handleHistoryDokumen={() => {
                  handleHistoryDokumen(
                    item?.kategori_dokumen?.id,
                    item?.id_dokumen,
                  );
                }}
              />
            </Grid>
          );
        })}

        {/* unggah perjanjian sewa kantor */}
        {/* <Grid item xs={12} md={6}>
          <MyUploadFile
            label="Unggah Perjanjian Sewa Kantor*"
            handleselectedFile={(e) =>
              handleselectedFiles(e, "doc-sewa-kantor")
            }
            fileName={fileNameSewaKantor}
            handleDeleteFile={() => handleDeleteFile("doc-sewa-kantor")}
          />
        </Grid> */}
        {/* unggah SK domisili kantor */}
        {/* <Grid item xs={12} md={6}>
          <MyUploadFile
            label="Unggah Surat Keterangan Domisili Kantor"
            handleselectedFile={(e) =>
              handleselectedFiles(e, "doc-domisili-kantor")
            }
            fileName={fileNameDomisiliKantor}
            handleDeleteFile={() => handleDeleteFile("doc-domisili-kantor")}
          />
        </Grid> */}
      </Grid>
    </>
  );
};

export default DokumenKantor;
